import { Navigate } from 'react-router';

import {
  ANY_SPORT_MARKET_COMMON_PACKS,
  ANY_SPORT_MARKET_HOME,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useSimplifiedNav } from '@sorare/core/src/hooks/commonGame/useSimplifiedNav';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

export const Market = () => {
  const { generateSportContextPath, sport } = useSportContext();
  const { showSimplifiedNav } = useSimplifiedNav(sport);
  const { isAndroidApp } = useIsMobileApp();
  if (showSimplifiedNav || isAndroidApp) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_MARKET_COMMON_PACKS)}
        replace
      />
    );
  }

  return (
    <Navigate to={generateSportContextPath(ANY_SPORT_MARKET_HOME)} replace />
  );
};

export default Market;
